module.exports = __webpack_public_path__ + "assets/img/thumb-Super-Obvious-Video.2249569e.jpg";